export const getTimeSlots = (
  selectedDate: Date,
  start: number = 0,
  end: number = 24,
  step: number = 0.25
) => {
  let timeSlots = [];
  for (let i = start; i < end; i += step) {
    let hour;
    let minutes = 0;
    const minuteValue = i - Math.floor(i);
    if (minuteValue > 0) {
      hour = i - minuteValue;
      if (minuteValue > 0.25) {
        if (minuteValue > 0.5) {
          minutes = 45;
        } else {
          minutes = 30;
        }
      } else {
        minutes = 15;
      }
    } else {
      hour = i;
    }
    timeSlots.push(
      new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        hour,
        minutes,
        0,
        0
      )
    );
  }
  return timeSlots;
};

export type Appointment = {
  available: number;
  capacity: number;
  end: Date;
  start: Date;
};

export const mockData = (
  selectedDate: Date = new Date(),
  start: number = 8,
  end: number = 16,
  step: number = 0.25
) => {
  const data: Appointment[] = [];
  for (let i = start; i < end; i += step) {
    let hour;
    let minutes = 0;
    const minuteValue = i - Math.floor(i);
    if (minuteValue > 0) {
      hour = i - minuteValue;
      if (minuteValue > 0.25) {
        if (minuteValue > 0.5) {
          minutes = 45;
        } else {
          minutes = 30;
        }
      } else {
        minutes = 15;
      }
    } else {
      hour = i;
    }
    const start = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate(),
      hour,
      minutes,
      0,
      0
    );
    const end = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate(),
      hour,
      minutes + 15,
      0,
      0
    );
    data.push({
      start,
      end,
      available: Math.random() % 2 === 0 ? 0 : 1,
      capacity: 1,
    });
  }
  return data;
};
